import { createSelector } from '@ngrx/store';

import { getJobsSelected } from '@collections/jobs';
import { isDefaultExperienceFilter, Job } from '@shared/models';

import { getJobPageState, JobPageState } from '../job.reducer';
import {
  initialJobMatchedCandidatesFilterState,
  JobFilterState,
  JobMatchedCandidatesFilter,
} from './matched-candidates-filter.reducer';

export const getJobPageFilterState = createSelector(getJobPageState, (state: JobPageState) =>
  !!state ? state.totalMatchesFilters : null,
);

export const getJobPageFilter = createSelector(
  getJobPageFilterState,
  getJobsSelected,
  (state: Partial<JobFilterState>, job: Partial<Job> | null) => {
    if (!job || !job.id) {
      return initialJobMatchedCandidatesFilterState;
    }

    const entities = state?.entities ?? {};

    return entities[job.id] ?? initialJobMatchedCandidatesFilterState;
  },
);

function countNumberForBadge(toCount: any[]) {
  return toCount?.length > 0 ? 1 : 0;
}

export const getJobPageFiltersBadgeNumber = createSelector(
  getJobPageFilter,
  (filter: Partial<JobMatchedCandidatesFilter>) =>
    !!filter
      ? countNumberForBadge(filter.keywords) +
        countNumberForBadge(filter.skills) +
        countNumberForBadge(filter.jobTitles) +
        countNumberForBadge(filter.schools) +
        (filter.enableLocationFilter ? countNumberForBadge(filter.locations) : 0) +
        (filter.enableYOEFilter && !isDefaultExperienceFilter(filter.experiences) ? 1 : 0) +
        countNumberForBadge(filter.companies) +
        (filter.minimumDegree ? 1 : 0) +
        countNumberForBadge(filter.fieldOfStudy) +
        (filter.internalOnTop ? 1 : 0) +
        (filter.referralOnTop ? 1 : 0)
      : 0,
);

export const getJobPageFilterInitialStateIsLoaded = createSelector(
  getJobPageFilter,
  (filter: JobMatchedCandidatesFilter) => filter.initialStateLoaded,
);
